import * as loanHelper from './loanHelper';
import * as dateHelper from './dateHelper';
import * as investmentHelper from './investmentHelper';
import * as permissionHelper from './permissionHelper'

const openInNewTab = (routeInformation) => {
  window.open(routeInformation.href, '_blank');
};

export { loanHelper, dateHelper, openInNewTab, investmentHelper, permissionHelper };
